import React, { useCallback } from 'react';
import Wizard from '@/components/atoms/Wizard';
import RawModal from '@/components/atoms/RawModal';
import useCreateRestaurantViewModel from './CreateRestaurantForm.viewmodel';
import { FormProvider } from 'react-hook-form';

interface CreateRestaurantFormProps {
    isOpen: boolean;
    onHide: () => void;
    brandId: string;
}

const CreateRestaurantForm: React.FC<CreateRestaurantFormProps> = ({ isOpen, onHide, brandId }) => {
    const { steps, form, onSubmit, isLoading, selectedStep, resetState } = useCreateRestaurantViewModel(brandId);

    const handleHide = useCallback(() => {
        resetState();
        onHide();
    }, [resetState, onHide]);

    return (
        <RawModal onHide={handleHide} isOpen={isOpen}>
            <FormProvider {...form}>
                <Wizard
                    steps={steps}
                    onValidate={form.handleSubmit(onSubmit)}
                    isLoading={isLoading}
                    selectedStep={selectedStep}
                    showStepper={true}
                />
            </FormProvider>
        </RawModal>
    );
};

export default CreateRestaurantForm;
